import Vue from "vue";
import VueRouter, { Route } from "vue-router";
import store from "@/store";
import { constants } from "@/utils/constants";
import Login from "@/views/Login";
import Home from "@/views/Home";
import DentalOffices from "@/views/DentalOffices/DentalOffices.vue";
import Talent from "@/views/Talent/Talent.vue";
import DuplicateReview from "@/views/DuplicateReview/DuplicateReview.vue";
import Invoices from "@/views/Invoices";
import StripeExpressAccounts from "@/views/StripeExpressAccounts/StripeExpressAccounts.vue";
import RawData from "@/views/RawData";
import JobBoard from "@/views/JobBoard";
import TableView from "@/views/TableView";
import History from "@/views/History";
import AvailableNow from "@/views/AvailableNow";
import Notes from "@/views/Notes";
import Disputes from "@/views/Disputes";
import PaymentIntegrity from "@/views/PaymentIntegrity";
import SNC from "@/views/SNC";
import SNCbyHygDa from "@/views/SNCbyHygDa";
import SncMerchRecipients from "@/views/SNC/SncMerchRecipients.vue";
import Resumes from "@/views/Resumes";
import ReviewHistory from "@/views/ReviewHistory";
import ManualShiftBooking from "@/views/ManualShiftBooking";
import ChatHistory from "@/views/ChatHistory";
import EmailTracker from "@/views/EmailTracker/EmailTracker.vue";
import BucketEmail from "@/views/BucketEmail/BucketEmail.vue";
import OfficeAcquisition from "@/views/OfficeAcquisition/OfficeAcquisition.vue";
import CronTrigger from "@/views/System/CronTrigger.vue";
import PartnerReferralCodes from "@/views/System/PartnerReferralCodes.vue";
import BulkPlacementFeeUpload from "@/views/System/BulkPlacementFeeUpload.vue";
import FreePeriod from "@/components/FreePeriod/FreePeriod.vue";
import OfficePromotions from "@/components/OfficePromotions/OfficePromotions.vue";
import BuildTrigger from "@/views/System/BuildTrigger.vue";
import FeatureFlags from "@/views/System/FeatureFlags.vue";
import MessageUsers from "@/views/System/MessageUsers.vue";
import JobBoardPartnerLink from "@/views/System/JobBoardPartnerLink.vue";
import PartnerAffiliation from "@/views/PartnerAffiliation";
import AuthCallback from "../views/AuthCallback.vue";
import GeoViz from "@/views/GeoViz/GeoViz.vue";
import Courses from "@/views/Courses";
import PhotoAnnounce from "@/views/PhotoAnnounce";
import SpamList from "@/views/SpamList";
import SupportAssistant from "@/views/SupportAssistant";

// We don't need fetchAuthSession or signOut directly in the guard anymore
// import { fetchAuthSession, signOut } from "aws-amplify/auth";

Vue.use(VueRouter);

const routes = [
  { path: "/home", redirect: "/" },
  {
    path: "/login",
    name: "login",
    component: Login,
    meta: { requiresAuth: false } // Public route
  },
  {
    path: "/auth/callback",
    name: "authcallback",
    component: AuthCallback,
    meta: { requiresAuth: false } // Public route
  },
  // --- Protected Routes (Assume requiresAuth: true by default) ---
  { path: "/", name: "home", component: Home },
  { path: "/talent", name: "talent", component: Talent },
  {
    path: "/duplicate-review",
    name: "duplicateReview",
    component: DuplicateReview
  },
  { path: "/dental-offices", name: "dentaloffices", component: DentalOffices },
  { path: "/invoices", name: "invoices", component: Invoices },
  {
    path: "/stripe-express-accounts",
    name: "stripeExpressAccounts",
    component: StripeExpressAccounts
  },
  { path: "/raw-data", name: "rawdata", component: RawData },
  { path: "/job-board", name: "jobBoard", component: JobBoard },
  // T2-6236: Reliability List repurposed as the live Available Now list.
  { path: "/available-now", name: "availableNow", component: AvailableNow },
  { path: "/Reliable", redirect: "/available-now" },
  { path: "/reliability-list", redirect: "/available-now" },
  {
    path: "/membership-integrity/:tablename",
    name: "MembershipIntegrity",
    component: TableView,
    props: (router: any) => ({
      tablename: router.params.tablename
    })
  },
  {
    path: "/tables/:tablename",
    name: "tables",
    component: TableView,
    props: (router: any) => ({
      tablename: router.params.tablename
    })
  },
  { path: "/history", name: "history", component: History },
  { path: "/review-history", name: "ReviewHistory", component: ReviewHistory },
  { path: "/notes", name: "notes", component: Notes },
  { path: "/disputes", name: "disputes", component: Disputes },
  {
    path: "/payment-integrity",
    name: "PaymentIntegrity",
    component: PaymentIntegrity
  },
  { path: "/SNC", name: "SNC", component: SNC },
  { path: "/SNCbyHygDa", name: "SNCbyHygDa", component: SNCbyHygDa },
  {
    path: "/snc-merch-recipients",
    name: "sncMerchRecipients",
    component: SncMerchRecipients
  },
  { path: "/Resumes", name: "resumes", component: Resumes },
  {
    path: "/manual-shift-booking",
    name: "manualShiftBooking",
    component: ManualShiftBooking
  },
  { path: "/chat-history", name: "chatHistory", component: ChatHistory },
  { path: "/email-tracker", name: "emailTracker", component: EmailTracker },
  { path: "/bucket-email", name: "bucketEmail", component: BucketEmail },
  {
    path: "/office-acquisition",
    name: "officeAcquisition",
    component: OfficeAcquisition
  },
  { path: "/system/cron", name: "cronTrigger", component: CronTrigger },
  { path: "/system/partner-codes", name: "partnerReferralCodes", component: PartnerReferralCodes },
  { path: "/system/bulk-placement-fees", name: "bulkPlacementFeeUpload", component: BulkPlacementFeeUpload },
  { path: "/system/free-periods", name: "regionalFreePeriods", component: FreePeriod },
  { path: "/system/office-promotions", name: "officePromotions", component: OfficePromotions },
  { path: "/system/build-trigger", name: "buildTrigger", component: BuildTrigger },
  { path: "/system/feature-flags", name: "featureFlags", component: FeatureFlags },
  { path: "/system/message-users", name: "messageUsers", component: MessageUsers },
  { path: "/system/job-board-partner-link", name: "jobBoardPartnerLink", component: JobBoardPartnerLink },
  { path: "/admin/partner-affiliation", name: "partnerAffiliation", component: PartnerAffiliation },
  { path: "/geo-viz", name: "geoViz", component: GeoViz },
  { path: "/courses", name: "courses", component: Courses },
  { path: "/photo-announce", name: "photoAnnounce", component: PhotoAnnounce },
  { path: "/spam-list", name: "spamList", component: SpamList },
  {
    path: "/support-assistant",
    name: "supportAssistant",
    component: SupportAssistant
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

// Navigation Guard
router.beforeEach(async (to: Route, from: Route, next: Function) => {
  // Handle unsaved changes prompt
  if (store.state.preparedDataToSave.length >= 1) {
    if (
      !confirm(
        "You have unsaved changes. Click 'OK' if you want to go to another page without saving data."
      )
    ) {
      return;
    }
    store.commit("modify", { property: "preparedDataToSave", value: [] });
  }

  // --- Authentication check based on localStorage ---
  const requiresAuth = to.matched.some(
    record => record.meta.requiresAuth !== false
  );
  const isPublicRoute = to.path === "/login" || to.path === "/auth/callback";

  // Check for the JWT in localStorage as the indicator of auth status for the guard
  const jwt =
    localStorage.getItem("adminApiJwt") || localStorage.getItem("jwt");
  const isAuthenticated = !!jwt; // Simple check: if JWT exists, assume authenticated FOR ROUTING

  // --- Decision Logic ---
  if (requiresAuth && !isAuthenticated) {
    next({ name: "login", query: { redirect: to.fullPath } });
    return;
  }

  if (!requiresAuth && isAuthenticated && isPublicRoute) {
    // Scenario 2: Public route (login/callback), but JWT exists
    next({ name: "home" }); // Redirect to home instead of login
    return;
  }

  // Special check for System Crons in production
  if (to.path === "/system/cron") {
    const hostname = window.location.hostname.toLowerCase();

    const isStagingOrDev =
      hostname.includes("beta") ||
      hostname.includes("staging") ||
      hostname === "localhost" ||
      hostname === "127.0.0.1" ||
      process.env.NODE_ENV === "development" ||
      process.env.NODE_ENV === "staging";

    const isProduction =
      hostname === "dashboard.tempstars.com" ||
      process.env.NODE_ENV === "production";

    if (isProduction && !isStagingOrDev) {
      // eslint-disable-next-line no-console
      console.warn("Access to System Crons blocked in Production");
      next({ name: "home" });
      return;
    }
  }

  // Partner Referral Codes - accessible to all authenticated admins
  if (to.path === "/system/partner-codes") {
    try {
      const userStr = localStorage.getItem("user");
      if (!userStr) {
        // No user data, deny access
        next({ name: "home" });
        return;
      }
    } catch (e) {
      // Error parsing user data, deny access
      next({ name: "home" });
      return;
    }
  }

  // Partner Affiliation - restricted to Developer role (role=1) only
  if (to.path === "/admin/partner-affiliation") {
    try {
      const userStr = localStorage.getItem("user");
      if (!userStr) {
        next({ name: "home" });
        return;
      }
      const user = JSON.parse(userStr);
      const role = user && user.role !== undefined ? parseInt(String(user.role), 10) : 0;
      if (role !== 1) {
        next({ name: "home" });
        return;
      }
    } catch (e) {
      next({ name: "home" });
      return;
    }
  }

  // Bulk Placement Fee Upload - restricted to Developer role (role=1) only (T2-5716).
  // The API is the authoritative gate (checkAdminRole1 middleware); this is
  // just a client-side convenience so the tab is hidden/blocked for non-devs.
  if (
    [
      "/system/bulk-placement-fees",
      "/system/free-periods",
      "/system/office-promotions",
      "/system/message-users",
      "/system/google-reviews-count",
      "/snc-merch-recipients"
    ].includes(to.path)
  ) {
    try {
      const userStr = localStorage.getItem("user");
      if (!userStr) {
        next({ name: "home" });
        return;
      }
      const user = JSON.parse(userStr);
      const role = user && user.role !== undefined ? parseInt(String(user.role), 10) : 0;
      if (role !== 1) {
        next({ name: "home" });
        return;
      }
    } catch (e) {
      next({ name: "home" });
      return;
    }
  }

  // Mobile Build Trigger - restricted to Developer role (role=1) only.
  // Triggering builds is high-impact (uploads to TestFlight / Play Internal),
  // so we keep it dev-only on both client and server. The API enforces this
  // via checkAdminRole1; this client-side guard prevents non-devs from even
  // navigating to the page directly.
  if (to.path === "/system/build-trigger") {
    try {
      const userStr = localStorage.getItem("user");
      if (!userStr) {
        next({ name: "home" });
        return;
      }
      const user = JSON.parse(userStr);
      const role = user && user.role !== undefined ? parseInt(String(user.role), 10) : 0;
      if (role !== 1) {
        next({ name: "home" });
        return;
      }
    } catch (e) {
      next({ name: "home" });
      return;
    }
  }

  next(); // Allow navigation
});

export default router;
